import {
  DummyDataResolvers,
  DummyDataResolver,
  FieldResolverFn,
} from './dummyData.types'

const augmentResolver = (
  fieldName: string,
  fieldResolver: FieldResolverFn<any, any>
): FieldResolverFn<any, any> => {
  return (parent, args, context, info) => {
    try {
      const clientDirective = info.field.directives?.find(
        x => x.name.value === 'client'
      )

      /**
       * If there is no @client directive added on the field
       * then always return value from an actual response.
       *
       * This is how it already should work according to Apollo docs
       * but it doesn't so we fix it ourselves
       *
       * see https://www.apollographql.com/docs/react/development-testing/client-schema-mocking/#4-toggle-on-real-data
       * > Once the feature is ready on the backend, just remove the @client directive from your query.
       * > You should now be able to see your real production data returned instead
       */
      if (!clientDirective) {
        return parent[fieldName]
      }
      return fieldResolver(parent, args, context, info)
    } catch (err) {
      console.log('dummy resolver', err)
    }
  }
}

export const augmentResolvers = <T>(resolvers: DummyDataResolvers<T>) =>
  Object.entries(resolvers)
    .map(([typeName, typeResolver]) => {
      return {
        [typeName]: Object.entries(typeResolver as DummyDataResolver<any>)
          .map(([fieldName, fieldResolver]) => ({
            [fieldName]: augmentResolver(fieldName, fieldResolver!),
          }))
          .reduce((l, r) => ({ ...l, ...r }), {}),
      }
    })
    .reduce((l, r) => ({ ...l, ...r }), {})
